import { gql } from '@nerdwallet/apollo';
import {
  BANKING_SUB_PRODUCT_TYPES,
  INVESTING_SUB_PRODUCT_TYPES,
  PRODUCT_TYPES,
} from '@nerdwallet/marketplace/constants';
import {
  getProductType,
  getSubProductType,
} from '@nerdwallet/marketplace/selectors/common';

export const PRODUCT_TYPE_UNSTRUCTURED_VERTICAL = {
  AUTOINSURANCE: 'auto_insurance',
  TAXES: 'taxes',
  TRAVEL: 'travel',
  BANKING: 'banking',
  CREDITCARDS: 'credit_cards',
  INVESTING: 'investing',
  MORTGAGES: 'mortgages',
  PERSONALLOANS: 'personal_loans',
};

export const PRODUCT_TYPE_NAME_MAPPING = {
  [PRODUCT_TYPES.CREDIT_CARDS]: 'Card',
  [BANKING_SUB_PRODUCT_TYPES.CHECKING]: 'Account',
  [PRODUCT_TYPES.BANKING]: 'Bank',
  [BANKING_SUB_PRODUCT_TYPES.CD]: 'CD',
  [BANKING_SUB_PRODUCT_TYPES.SAVINGS]: 'Account',
  [BANKING_SUB_PRODUCT_TYPES.MONEY_MARKET]: 'Account',
  [INVESTING_SUB_PRODUCT_TYPES.BROKER]: 'Broker',
  [INVESTING_SUB_PRODUCT_TYPES.INVESTMENT_ADVISOR]: 'Robo-advisor',
  [PRODUCT_TYPES.PERSONAL_LOANS]: 'Lender',
  [PRODUCT_TYPES.EDUCATION_LOANS]: 'Lender',
};

export const getProductName = (entity) => {
  const productType = getProductType(entity);
  switch (productType) {
    case PRODUCT_TYPES.BANKING:
    case PRODUCT_TYPES.INVESTING:
      return (
        PRODUCT_TYPE_NAME_MAPPING[getSubProductType(entity)] ||
        PRODUCT_TYPE_NAME_MAPPING[productType]
      );

    default:
      return PRODUCT_TYPE_NAME_MAPPING[productType];
  }
};

export const MARKETPLACE_ENTITY_QUERY = gql`
  query MarketplaceEntityQuery($id: ID!) {
    marketplaceEntityV2(id: $id) {
      entityType
      id
      name
      productType
      status
      updatedAt
      versionId
      ... on CreditCardsOfferV2 {
        __typename
        annualFee
        aprMax
        aprMin
        displayName
        id
        isMonetizing
        legacyId
        marketingBullets
        maxFico
        minFico
        monetizable
        phoneNumber
        prequalLink
        prequalLinkText
        product {
          id
          entityType
          name
        }
        productType
        reviewLink
        slug
        starRating
        status
        structuredContentCons
        structuredContentPros
        termsAndFeesLink
        versionId
        analyticsProps {
          ...AnalyticsProps
        }
        bestOfAwards {
          ...BestOfAwards
        }
        creditScoreComparisonContent {
          ...CreditScoreComparisonContent
        }
        cta {
          ...ccmpc_Cta
        }
        image {
          ...Image
        }
        placementDrivers {
          ...PlacementDrivers
        }
        ratesAndFeesCta {
          ...RatesAndFeesCta
        }
        recommendedCreditScoreRangeDetails {
          ...RecommendedCreditScoreRangeDetails
        }
        starRatingTooltip
        structuredContentTagline
        useLargeImageFootprint
      }
    }
  }
  # fragment ccmpc_Cta on EntityPlacementCTA {
  #   __typename
  #   link
  #   showIcon
  #   subtext
  #   text
  #   type
  # }

  # fragment AnalyticsProps on EntityPlacementAnalyticsProps {
  #   __typename
  #   institutionId
  #   offerId
  #   productId
  #   hasLegacyImpression
  #   legacyAdditionalEventData
  #   legacyIssuer
  #   legacySlug
  #   legacyVertical
  # }

  # fragment BestOfAwards on BestOfAward {
  #   __typename
  #   year
  #   category
  # }

  # fragment CreditScoreComparisonContent on CreditCardsCreditScoreComparisonContent {
  #   __typename
  #   pointDifference
  #   relativeScoreLabel
  #   scoreToCompare
  # }

  # fragment Image on EntityPlacementImage {
  #   __typename
  #   alt
  #   height
  #   resizableImagePath
  #   source
  #   sourceLarge
  #   sourceMedium
  #   width
  # }

  # fragment PlacementDrivers on EntityPlacementDriver {
  #   __typename
  #   description
  #   label
  #   labelTooltip
  #   value
  #   tooltip
  #   valueTooltip
  #   valueTooltipHasHtml
  # }

  # fragment RatesAndFeesCta on EntityPlacementCTA {
  #   __typename
  #   link
  #   showIcon
  #   subtext
  #   text
  #   type
  # }

  # fragment RecommendedCreditScoreRangeDetails on CreditCardsRecommendedCreditScoreRangeDetails {
  #   __typename
  #   creditScoreRange
  #   description
  # }
`;
